const setUrlParams = (state) => {
	window.history.pushState({}, '', `?s=${state.searchQuery}`);
};

export default setUrlParams;
